import Link from "next/link";

const SignupButton = () => {
  // TODO: LOGOUT FUNCTION
  return (
    <div className="button__signup">
      <Link href="/signup">SIGNUP</Link>
    </div>
  );
};

export default SignupButton;
